// extracted by mini-css-extract-plugin
export default {"st1":"SearchIcon_st1__9F+jK"};